export default {
  meta: {
    title: '更多',
    url: '/home', // 埋点字段，上报归属的模块
    urlName: '首页' // 埋点字段，上报归属的模块
  }
};
